import { DEPENDENCY_CONDITION } from '../../../../utils/constant';
import { PAYMENT_METHOD } from '../selectOptions';

export const honorBoxPromise = {
  firstBasicInformation: [
    {
      name: 'nid',
      label: 'NID',
      type_field: 'inputNumber',
      fixed: true,
    },
    {
      name: 'property_name',
      label: 'Nombre',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'registration_sheet',
      label: 'Folio matrícula',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'city',
      label: 'Ciudad',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'client_name',
      label: 'Nombre del cliente',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'client_id',
      label: 'Cédula',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'client_phone',
      label: 'Número(s) de teléfono',
      type_field: 'inputNumber',
      fixed: true,
    },
    {
      name: 'client_email',
      label: 'Correo cliente',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'intention_chart_date',
      label: 'Fecha carta de intención',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'tentative_promise_date',
      label: 'Fecha tentativa promesa',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'promise_request_date',
      label: 'Fecha solicitud promesa',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'promise_radication_date',
      label: 'Fecha radicación promesa',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'promise_enter_date',
      label: 'Fecha carga promesa',
      type_field: 'inputDate',
      fixed: true,
    },
  ],
  firstAnalystInformation: [
    {
      name: 'returned_promises',
      label: 'Número de promesas devueltas',
      type_field: 'inputNumber',
      fixed: false,
    },
  ],
  secondBasicInformation: [
    {
      name: 'promise_signature_date',
      label: 'Fecha firma promesa',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'scripture_deal_date',
      label: 'Fecha escritura pactada',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'latest_otrosi_date',
      label: 'Fecha último otrosí',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'latest_otrosi_reason',
      label: 'Razón último otrosí',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'otrosi_scripture_deal_date',
      label: 'Fecha escritura pactada otrosí',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'procedure_analyst',
      label: 'Analista de trámites',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'severance_entity',
      label: 'Entidad cesantías',
      type_field: 'input',
      fixed: true,
    },
  ],
  secondAnalystInformation: [
    {
      name: 'subsidy',
      label: 'Subsidio',
      type_field: 'inputNumber',
      fixed: false,
    },
  ],
  thirdBasicInformation: [
    {
      name: 'payment_method',
      label: 'Forma de pago',
      type_field: 'select',
      multiple_values: {
        options: PAYMENT_METHOD,
      },
      fixed: false,
    },
  ],
  thirdAnalystInformation: [
    {
      name: 'last_client_communication_date_pch',
      label: 'Fecha última comunicación cliente',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'fiduciary_bonding_sending',
      label: 'Envío vinculación fiduciaria',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'aproved_bonding',
      label: 'Vinculación aprobada',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'dann_pa_colpatria_docs_radication',
      label: 'Radicación Docs en Dann/PA Colpatria',
      type_field: 'inputDate',
      fixed: true,
    },
    {
      name: 'dann_colpatria_docs_aproval',
      label: 'Aprobación Docs Dann/Colpatria',
      type_field: 'inputDate',
      fixed: true,
    },
  ],
  fourthBasicInformation: [
    {
      name: 'external_lawyer_name_pch',
      label: 'Nombre abogado externo',
      type_field: 'input',
      fixed: false,
    },
    {
      name: 'external_lawyer_contact_pch',
      label: 'Contacto abogado externo',
      type_field: 'input',
      fixed: false,
    },
    {
      name: 'adviser',
      label: 'Asesor',
      type_field: 'input',
      fixed: true,
    },
    {
      name: 'adviser_contact',
      label: 'Contacto asesor',
      type_field: 'input',
      fixed: true,
    },
  ],
  fourthAnalystInformation: [
    {
      name: 'et_avaluo_payment_date_pch',
      label: 'Fecha pago Avalúo & ET',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'bank_document_signature_date_pch',
      label: 'Fecha firma de docs en banco',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'avaluo_request_date_pch',
      label: 'Fecha solicitud avalúo',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'avaluo_fulfilled_date_pch',
      label: 'Fecha realización avalúo',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'avaluo_aproved_receipt_pch',
      label: 'Recibo avalúo aprobado',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'et_docs_radication_date_pch',
      label: 'Fecha radicación docs ET',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'et_aproval_date_pch',
      label: 'Fecha aprobación ET',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'et_aproval_date_more_pch',
      label: 'Fecha aprobación ET, entrega minuta & legalización crédito',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'memorandum_request_pch',
      label: 'Solicitud minuta',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'memorandum_receipt_pch',
      label: 'Recepción minuta',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'memorandum_legal_aproval_habi_pch',
      label: 'Aprobación minuta legal (Habi)',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'fidu_dann_colpatria_memorandum_aproval_pch',
      label: 'Aprobación minuta Fidu/Dann/Colpatria',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'caja_honor_memorandum_aproval',
      label: 'Aprobación Minuta Caja Honor',
      type_field: 'inputDate',
      fixed: false,
    },
  ],
  fifthBasicInformation: [
    {
      name: 'real_scripture_date',
      label: 'Fecha escritura real',
      type_field: 'inputDate',
      fixed: true,
      dependencies: [
        {
          on_field: 'property_address',
          condition: DEPENDENCY_CONDITION.NOT_EMPTY,
        },
        {
          on_field: 'property_name',
          condition: DEPENDENCY_CONDITION.NOT_EMPTY,
        },
        {
          on_field: 'client_name',
          condition: DEPENDENCY_CONDITION.NOT_EMPTY,
        },
        {
          on_field: 'client_id',
          condition: DEPENDENCY_CONDITION.NOT_EMPTY,
        },
        {
          on_field: 'client_phone',
          condition: DEPENDENCY_CONDITION.NOT_EMPTY,
        },
        {
          on_field: 'address_residence_notification',
          condition: DEPENDENCY_CONDITION.NOT_EMPTY,
        },
      ],
    },
    {
      name: 'sale_scripture_number',
      label: 'Número de escritura',
      type_field: 'inputNumber',
      fixed: true,
    },
  ],
  fifthAnalystInformation: [
    {
      name: 'good_standing_scripture_pch',
      label: 'Paz y salvo escrituración',
      type_field: 'select',
      multiple_values: {
        options: [
          {
            label: 'Si',
            value: 'si',
          },
          {
            label: 'No',
            value: 'no',
          },
        ],
      },
      fixed: false,
    },
    {
      name: 'arras_date',
      label: 'Fecha arras',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'arras_value',
      label: 'Valor arras',
      type_field: 'inputCurrency',
      fixed: false,
    },
    {
      name: 'first_real_payment_severance',
      label: 'Fecha real primer pago / Cesantías',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'first_payment_value_severance',
      label: 'Valor primer pago / Cesantías',
      type_field: 'inputCurrency',
      fixed: false,
    },
    {
      name: 'counter_scripture_payment_date_pch',
      label: 'Fecha pago contra escritura',
      type_field: 'inputDate',
      fixed: false,
    },
    {
      name: 'counter_scripture_payment_value_pch',
      label: 'Valor pago contra escritura',
      type_field: 'inputCurrency',
      fixed: false,
    },
    {
      name: 'pending_value_to_be_disbursed_bank_pch',
      label: 'Valor pendiente desembolso banco',
      type_field: 'inputCurrency',
      fixed: false,
    },
  ],
  sixthBasicInformation: [
    {
      name: 'selling_price',
      label: 'Precio de venta',
      type_field: 'inputCurrency',
      fixed: true,
    },
  ],
  sixthAnalystInformation: [
    {
      name: 'selling_price_difference',
      label: 'Diferencia precio de venta - valor pagos',
      type_field: 'inputCurrency',
      fixed: true,
    },
  ],
};
